<div class="flex min-h-full w-full flex-col">
  <div class="sticky top-0 z-10 flex w-full bg-white p-4">
    @for (labelAndWidth of labelsAndWidths(); track $index) {
      <span class="box-border px-1 text-left font-bold" [ngClass]="labelAndWidth[1]">
        {{ labelAndWidth[0] }}
      </span>
    }
    @let classification = isClassificationView ? tableModel().rowClassification : undefined;
    @if (classification) {
      <span class="box-border w-[32px] px-1 text-left font-bold">
        {{ classification.classLabel }}
      </span>
    }
    @if (hasActionButtonInRows) {
      <!-- If there is an extra action button (e.g. 'delete row') in every row, we need
         to render an extra space here such that the headers align with the columns -->
      <span class="min-w-[24px]"></span>
    }
  </div>
  <div
    class="flex min-h-0 grow flex-col pb-5"
    (waMutationObserver)="onTableChange()"
    childList
    #table>
    @for (row of tableRows.controls; track row; let rowIndex = $index) {
      <ct-extraction-table-row
        [row]="row"
        [tableModel]="capturingConfig().tableModel"
        [visibleFieldModels]="visibleFieldModels()"
        [isTableLayoutEditable]="isTableLayoutEditable"
        [topAndBottomAddLineControls]="rowIndex === tableRows.length - 1"
        [currentTableFieldId]="currentTableCell()?.field?.controls?.id?.value"
        [rowIndex]="rowIndex"
        [isClassificationView]="isClassificationView"
        (addRowAtIndex)="rowAdded.emit($event)"
        (deleteRowAtIndex)="rowDeleted.emit($event)"
        (newCurrentFieldIndex)="updateFieldIndex($event)"
        (manualValueChange)="onManualValueChange($event)"
        [currentRowToClassify]="currentRowToClassify()"
        (rowSelected)="rowSelected.emit($event)"
        (outsideClick)="currentRowToClassify.set(undefined)"
        (tableCallback)="onTriggerTableCallback($event)" />
    }
  </div>
</div>
